"use strict";

module.exports = {
    trackingPath: 'https://api.agentshield.com/t/1x1clear.gif',
    server: 'https://app.agentshield.com',
    restPath: 'https://toolbox.agentshield.com/agent-shield-1.0/rest',
    widgetHost: 'https://widgets.agentshield.com',
    toolboxHost: 'https://toolbox.agentshield.com',
    intercomAppId: 'ms2t4wtj',
    intercomAppIdAgent: 'ms2t4wtj',
    segmentId: 'V51M9LOJIz3xt5Sce07Cn2AfekK6Ocye',
    rollbarEnabled: true,
    rollbarId: "7a90fad9cc7144689883252a2f5e888f",
    googleAnalyticsId: 'UA-462934-5',
    safeAPIs: [
        // WCI
        // Tidewater Preserve	
        "bfb90cec-1e15-4ef2-b16a-4a8b6494e912",
        // Venetian Golf & River Club	
        "dc270491-d1db-46fc-9f9c-672817479bf1",
        // Westshore Yacht Club	
        "02ff3080-feed-4e54-ab25-1598b30215a3",
        // Hampton Park at Gateway	
        "62041474-79f7-4c0f-84ee-8065fde96bf4",
        // Pelican Preserve	
        "4c4ddb7a-89e9-4305-983e-15b76172ae29",
        // Manchester Square	
        "6b29af5f-513d-4a8d-a265-a394884685fa",
        // Tiburon	
        "c3efd15a-d372-4ec8-ba6c-e3a922f416bb",
        // Heron Bay	
        "5c639c33-2fcf-4724-90e6-a0bbf9fedeed",
        // WCI Communities	
        "2eda578a-6586-47bf-9b93-2e7b0531dfd7",
        // Sarasota National	
        "e0877f1f-f379-4758-8ba3-298ac66f343b",
        // Porto Romano at Miromar Lakes	
        "24b15e60-361f-4928-9f3e-8c275682b469",
        // The Colony Golf & Bay Club	
        "b2cf4704-a371-4b07-99d1-47ab40cc8331",
        // Raffia Preserve	
        "6b0ad401-010c-43a0-836c-9f69aea7d3d7",
        // Shadow Wood Preserve	
        "0b94cfc6-6e78-4b7a-8329-640339ceae6a",
        // Livingston Lakes	
        "91f21d7e-0ca2-4457-b7d6-e3751d8684ec",
        // LaMorada	
        "eb397006-224c-4bf7-a193-f5ef5255aa5f",
        // Artesia Naples	
        "ede7915a-2435-4d13-ac86-d007da94d994",
        // Carrara at Talis Park	
        "3754e313-64cb-4979-acbb-f7d0fe65e9a3",
        // The Links at Rosedale	
        "e54b71f6-41e0-4c4f-bc42-c4f23d79ce14",
        // Estates at Tuscany	
        "9ef23601-95e4-401b-bd7d-61543c34d2ec",
        // Altaira	
        "5e4bb013-4ff7-463a-a2c8-9c17cee11f6c",
        // Woodlands at Ibis	
        "3ffd1ddf-fca9-4a14-ac9e-e8e88cbd991d",
        // Country Club East	
        "3f32eb7f-9a4a-49da-8865-a958ca056bfb",
        // Lost Key	
        "d1543b45-75f5-4e01-a2f4-9f3173f28910",
        // Timberwood Preserve	
        "751a1ade-7464-46c4-b085-8cf0cac818a6",
        // Arborwood Preserve	
        "036ebd31-159e-479a-8e12-fcf95927e483",
        
        // NON_WCI
        // Paseo	
        "cb3a409c-a024-45c6-9bc7-59cb3ac35b20",
        // Lely Resort	
        "683434fb-c0a5-49a4-997f-76848cf89bea",
        // Infinity	
        "77a9f37f-3222-4e33-b535-67708fffa36c",
        // NewNaplesCommunities.com	
        "e0c4f9fa-9176-49e7-8b26-3a293ca28e31",
        // Fiddler's Creek	
        "3259c99b-5e9c-4a7d-9799-15d44f22d5b3",
        // Ventanas Hotel & Residences	
        "05ae9bd5-4194-4779-a931-f6c416b0f3aa",
        // River Strand	
        "600ceb30-2af6-4f50-9da7-5ff30a339417",
        // AQUA at Pelican Isle, Naples	
        "b58d14f8-ecf4-418e-a7a4-746de0d4b002",
        // Hilton Head Lakes	
        "8491c607-853b-44ef-a786-9cda74b01565",
        // Southern Premier Homes	
        "eb13e3fb-5b11-47ba-a123-1eb8d9915791",
        // Talis Park	
        "69c51a4f-4ac5-4c91-a99f-8e95565e8f5b",
        // Cabo Del Mar Village	
        "0b62257c-5094-41c9-9051-d22ab5428e5d",
        // Miromar Lakes Beach & Golf Club	
        "d28be314-3beb-4a96-8e9c-ef0078b42d21",
        // Copala Los Cabos	
        "0b931a67-be72-4829-8597-0fa882b4c2af",
        // Grand Oaks Venice	
        "915a066f-483a-41a5-b83e-f79c58163f87",
        // Granada Park	
        "69a4e378-458e-4c20-a8e4-437f9a175e1d",
        // Island Court Venice	
        "af794fe7-e2cf-4c53-9ff0-32a129bec75a",
        // Sarasota National	
        "e0877f1f-f379-4758-8ba3-298ac66f343b",
        // Quail West	
        "f46ab6b1-9dc4-424a-a29a-0ce0e2f4b96e",
        // VUE Sarasota Bay	
        "087718a5-a755-4f4c-97e4-31ce94897c23",
        // Sansara	
        "3a16a9a7-e598-428c-a365-66a41a27892b",
        // Mirabella at Village Green	
        "3b4a918e-d530-4fa5-9a27-388926508c9b",
        // Hidden Harbor	
        "2d44d75c-fe4e-4fa1-8f21-adc2fac22297",
        // Coral Caye	
        "734d6810-2ed9-4351-8d23-1b0d7b760e7f",
        // ??
        "c0875816-9f00-11e5-8437-0ac300bf0013",
        // Edgewater at Hidden Bay	
        "5c720073-e61e-4124-b2d4-34cb26c0b5a7",
        // Petén Seaside Community	
        "d1f1123e-d1b6-4e13-ad2f-133f00dc3b37",
        // Kinuh	
        "f0e91ada-481e-478f-913d-46e10da4f9c6"        
    ]
};
